export const Role = {
  MANAGER: 'MANAGER',
  TECHNICIAN: 'TECHNICIAN',
} as const;

export type RoleType = (typeof Role)[keyof typeof Role];
